/**
 * created by wang lei
 前插入列页面
 *
 */
import React, {Component} from 'react';
import insertColumnBefore from './insertColumnBefore.png';
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

export default class InsertColumnBeforeTool extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            insertColumnBefore:false
        }
    }
    /**
     * 监听内容变化
     */
    listenContentChange(){
        let insertColumnBefore = this.props.editor.queryCommandState('deleteTable')
        this.setState({insertColumnBefore: insertColumnBefore === 0});
    }

    /**
     * 监听编辑器点击
     */
    listenContentClick(){
        let insertColumnBefore = this.props.editor.queryCommandState('deleteTable')
        this.setState({insertColumnBefore: insertColumnBefore === 0});
    }
    render() {
        return (
            <span style={{cursor:"pointer",opacity:this.state.insertColumnBefore ? "1":"0.3"}}>
                <img className={"editor-insert-column-before-tool-btn"} src={insertColumnBefore} onClick={()=>this.props.editor.execCommand("insertcol")}/>
                {this.state.insertColumnBefore ? <style>{`
                .editor-insert-column-before-tool-btn{
                    border: 1px solid #f2f6fc
                }
                .editor-insert-column-before-tool-btn:hover{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                }
                .editor-insert-column-before-tool-btn:active{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                }
            `}</style> : <style>{`
                .editor-insert-column-before-tool-btn{
                    border: 1px solid #f2f6fc
                }
                .editor-insert-column-before-tool-btn:hover{
                    border: 1px solid transparent
                }
                .editor-insert-column-before-tool-btn:active{
                    border: 1px solid transparent
                }
            `}</style>}

            </span>
        )
    }

}